module.exports = __webpack_public_path__ + "img/tu04.8899de45.png";